goog.provide("shadow.js.shim.module$raw_body$default");
shadow.js.shim.module$raw_body$default = esm_import$raw_body.default;
